export const firebaseConfig = {
    apiKey: "AIzaSyBdaWWsrhEzLyaTk4jNNLTdBxGYwG4kfGg",
    authDomain: "uffl-38387.firebaseapp.com",
    projectId: "uffl-38387",
    storageBucket: "uffl-38387.appspot.com",
    messagingSenderId: "1064441433367",
    appId: "1:1064441433367:web:b5738b6bfa02b265567b52"
  };
  